module.exports = __webpack_public_path__ + "assets/1792649897182/img/footer-bg.0720fc8f.png";